module.exports = __webpack_public_path__ + "static/media/twain.49940ef6.jpg";